import { Injectable, OnInit } from '@angular/core';
import { HttpBaseService } from './http-base.service';
import { lastValueFrom } from 'rxjs';
import { Configuration } from '../interfaces/settings.interface';
import { StorageService } from './storage.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  configuration!: Configuration;
  
  constructor(private http:HttpBaseService, private storageService: StorageService) { 
    if(!this.configuration){
      this.configuration = this.storageService.getLocalStorageItem('configuration');
    }
  }

  async getConfiguration(){
    this.configuration = await lastValueFrom(this.http.get('configurations'));
    this.storageService.setLocalStorageItem('configuration', this.configuration)
  }

  /**
   * Null-safe since MP-5750: a CLIENT session never fetches `configurations`
   * (the resource answers 403 for that role), so with no document the flag
   * falls back to the build-time tenant, which is the same truth for the
   * dashboard shell.
   */
  getPwcFlag(){
    if(!this.configuration){
      this.configuration = this.storageService.getLocalStorageItem('configuration')
    }
    if (!this.configuration?.pwcEnabled) {
      return environment.isPWCEnabled;
    }
    return this.configuration.pwcEnabled.enabled || false;
  }

  getMultiTenantFlag(){
    return this.configuration.multiTenant.enabled || false;
  }

  /**
   * Client portal capability (MP-5715). Null-safe on purpose: the configuration
   * is fetched once at login, and tenant documents created before MP-5712 have
   * no clientPortal block, so a missing document or block reads as off.
   */
  isClientPortalEnabled(): boolean {
    if (!this.configuration) {
      this.configuration = this.storageService.getLocalStorageItem('configuration');
    }
    return !!this.configuration?.clientPortal?.enabled;
  }
}
